import React, { FC } from 'react';
import { Col, Row, Form } from 'antd';
import { useTranslate } from '@refinedev/core';
import { DatePicker, Input, Select, FormItem } from 'components/ui';
import { useInnSelectProps } from 'hooks/preliminary-application/useDictionarySelectProps';
import styles from './steps.module.scss';

interface Step1DrugInfoProps {
    showInternationalName?: boolean;
    showRegDate?: boolean;
    regDateLabel?: string;
}

export const Step1DrugInfo: FC<Step1DrugInfoProps> = ({
    showInternationalName = true,
    showRegDate = false,
    regDateLabel,
}) => {
    const t = useTranslate();
    const form = Form.useFormInstance();

    const innHook = useInnSelectProps?.();
    const innProps = innHook?.selectProps ?? [];

    return (
        <div className={styles.stepContainer}>
            <h2 className={styles.stepTitle}>
                {t(
                    'preliminary-applications.wizard.step1.title',
                    'Відомості про препарат'
                )}
            </h2>

            <Row gutter={[16, 20]}>
                {showRegDate && (
                    <Col xs={24}>
                        <FormItem
                            name="reg_date"
                            rules={[
                                {
                                    required: true,
                                    message: t(
                                        'validation.required',
                                        'This field is required'
                                    ),
                                },
                            ]}
                        >
                            <DatePicker
                                format="DD.MM.YYYY"
                                style={{ width: '100%' }}
                                label={
                                    regDateLabel ??
                                    t(
                                        'preliminary-applications.fields.reg_date',
                                        'Дата'
                                    )
                                }
                                placeholder={t(
                                    'preliminary-applications.fields.select_date',
                                    'Виберіть дату'
                                )}
                                requiredMark
                            />
                        </FormItem>
                    </Col>
                )}

                <Col xs={24}>
                    <FormItem
                        name="medication_name"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'validation.required',
                                    'This field is required'
                                ),
                            },
                        ]}
                    >
                        <Input
                            label={t(
                                'preliminary-applications.fields.medication_name',
                                'Назва лікарського засобу'
                            )}
                        />
                    </FormItem>
                </Col>

                <Col xs={24}>
                    <FormItem
                        name="release_form"
                        rules={[
                            {
                                required: true,
                                message: t(
                                    'validation.required',
                                    'This field is required'
                                ),
                            },
                        ]}
                    >
                        <Input
                            label={t(
                                'preliminary-applications.fields.release_form',
                                'Форма випуску'
                            )}
                        />
                    </FormItem>
                </Col>

                {showInternationalName && (
                    <Col xs={24}>
                        <FormItem
                            name="international_name_id"
                            getValueFromEvent={(selected: any) =>
                                selected?.value
                            }
                            getValueProps={(value: any) => {
                                if (!value) return { value: undefined };
                                const option = innProps?.options?.find(
                                    (o: any) => o.value === value
                                );
                                return {
                                    value: option
                                        ? {
                                              label: option.label,
                                              value: option.value,
                                          }
                                        : { value },
                                };
                            }}
                        >
                            <Select
                                {...innProps}
                                allowClear
                                label={t(
                                    'preliminary-applications.fields.active_ingredient_inn',
                                    'Дієва (-і) речовина (-и) (МНН)'
                                )}
                            />
                        </FormItem>
                    </Col>
                )}
            </Row>
        </div>
    );
};
